<template>
  <div>
    {{ periodText }}
  </div>
</template>

<script>
import { Period } from '@/models/Report/IntervalReport/Constants'

const periodItems = [
  { value: Period.YESTERDAY, text: '前日分' },
  { value: Period.LAST_7_DAYS, text: '過去7日分' },
  { value: Period.LAST_30_DAYS, text: '過去30日分' },
  { value: Period.CURRENT_MONTH, text: '今月分' },
  { value: Period.LAST_MONTH, text: '先月分' },
  { value: Period.TOTAL, text: '全期間' },
]

export default {
  name: 'IntervalReportListPeriod',
  props: {
    period: {
      type: [String, Object],
      default: null,
      require: true,
    },
  },
  computed: {
    periodText() {
      if (periodItems.map(item => item.value).includes(this.period)) {
        return periodItems.find(item => item.value === this.period).text
      } else {
        const endDate = this.period.endDate ? this.period.endDate : ''
        return `${this.period.startDate} ~ ${endDate}`
      }
    },
  },
}
</script>

<style scoped></style>
